import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Milk extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): Milk {
    if (value < 0) {
      throw new Error('正数である必要があります');
    }
    return new Milk(value);
  }

  /** ラベル */
  static get label(): string {
    return 'ミルク(ml)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '120';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {};
  }

  /** キー */
  static get key() {
    return 'milk';
  }

  /** タイプ */
  static get type() {
    return 'number';
  }
}
